'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
require('./enums-de2d9d36.js');
var useBooleanState_hook = require('./use-boolean-state.hook-8d04931f.js');
var styles$q = require('./styles-41eae736.js');
var component$y = require('./component-ad6581c1.js');

var useItemClick = function (closePicker, selectedValue) { return React.useCallback(function (value) {
    if (value === selectedValue) {
        closePicker();
    }
}, [selectedValue, closePicker]); };
var usePicker = function (items, selectedValue) {
    var _a = useBooleanState_hook.useBooleanState(false), isPickerActive = _a.value, closePicker = _a.setFalse, togglePickerActive = _a.toggle;
    var pickerLabel = React.useMemo(function () { var _a; return (_a = items === null || items === void 0 ? void 0 : items.find(function (_a) {
        var value = _a.value;
        return value === selectedValue;
    })) === null || _a === void 0 ? void 0 : _a.label; }, [items, selectedValue]);
    var wheelPickerRef = React.useRef(null);
    return {
        isPickerActive: isPickerActive,
        pickerLabel: pickerLabel,
        selectedValue: selectedValue,
        onItemClick: useItemClick(closePicker, selectedValue),
        closePicker: closePicker,
        togglePickerActive: togglePickerActive,
        wheelPickerRef: wheelPickerRef,
    };
};

var HqoWheelPicker = function (_a) {
    var items = _a.items, label = _a.label, placeholder = _a.placeholder, doneButtonLabel = _a.doneButtonLabel, required = _a.required, disabled = _a.disabled, value = _a.value, onChange = _a.onChange, error = _a.error;
    var _b = usePicker(items, value), isPickerActive = _b.isPickerActive, pickerLabel = _b.pickerLabel, selectedValue = _b.selectedValue, onItemClick = _b.onItemClick, closePicker = _b.closePicker, togglePickerActive = _b.togglePickerActive, wheelPickerRef = _b.wheelPickerRef;
    return (React__default.createElement(styles$q.Container, { ref: wheelPickerRef, "data-testid": disabled ? 'read-only-select' : undefined },
        React__default.createElement(component$y.HqoPicker, { label: label, placeholder: placeholder, isActive: isPickerActive, value: pickerLabel, onClick: togglePickerActive, required: required, disabled: disabled, error: error }),
        isPickerActive && (React__default.createElement(styles$q.WheelPickerStyled, { itemHeight: 38, defaultValue: selectedValue, items: items, onChange: onChange, onItemClick: onItemClick, outsideClickParams: { onClickOutside: closePicker, outsideClickRef: wheelPickerRef }, doneButton: doneButtonLabel, className: "wheel-picker" }))));
};

exports.HqoWheelPicker = HqoWheelPicker;
